import TakipXmlParser from "./TakipXmlParser";
import {DosyaFormDataInterface} from "./DosyaFormDataInterface";
import {MtsDosyaFormData} from "./MtsDosyaFormData";
import {MtsXmlParser} from "./MtsXmlParser";

export interface XmlParseItem {
    success: boolean;
    data: TakipXmlParser | null;
    message: string;
}

export default class XmlController {
    /**
     * XML 1.0 Char üretimine aykırı kontrol karakterlerini kaldırır (ör. U+001C File Separator).
     * TAB (U+0009), LF (U+000A), CR (U+000D) korunur.
     */
    private static stripInvalidXml10Chars(input: string): string {
        if (input == null || input === "") {
            return input;
        }
        return input.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\uFFFE\uFFFF]/g, "");
    }

    static async parse(xml: string, formData: DosyaFormDataInterface): Promise<XmlParseItem[]> {
        const result: XmlParseItem[] = [];
        xml = XmlController.stripInvalidXml10Chars(xml);
        const elem = document.createElement("container");
        elem.innerHTML = xml;
        const dosyaNodeList = elem.querySelectorAll("dosya");
        let dosyaIndex = 1;
        for (const dosya of dosyaNodeList) {
            try {
                const takip = await TakipXmlParser.parse(dosya, formData);
                result.push({success: true, data: takip, message: ""});
            } catch (e) {
                const message = e.message ? e.message : String(e);
                result.push({success: false, data: null, message: `[Dosya ${dosyaIndex} XML Hatası] ${message}`});
            }
            dosyaIndex++;
        }
        return result;
    }
    static async readXmlWithEncoded(file: Blob): Promise<any>{
        return new Promise((resolve,reject)=>{
            try{
                let encodingControl = false;
                if (file.type == "text/xml" || file.type == "application/xml") {
                    let reader = new FileReader();
                    reader.readAsText(file);
                    reader.onloadend =  () => {
                        let xmlData: any = reader.result;
                        if (!xmlData.trim().startsWith('<?xml')) {
                            console.log("XML bildirim satırı ekleniyor");
                            xmlData = '<?xml version="1.0" encoding="UTF-8"?>\n' + xmlData;
                        }
                        
                        if(encodingControl == false){
                            if (xmlData.indexOf('encoding') >= 0) {
                                let hangiTirnakIsareti = '"';
                                if(xmlData.indexOf("encoding='") >= 0)
                                    hangiTirnakIsareti = "'";
                                let encoding = xmlData.split('encoding='+hangiTirnakIsareti)[1].split(hangiTirnakIsareti)[0];
                                encodingControl = true;
                                console.log("encoding",encoding,encodingControl);
                                reader.readAsText(file, encoding);
                            } else {
                                // Encoding bilgisi yoksa direkt olarak resolve et
                                return resolve(XmlController.stripInvalidXml10Chars(xmlData));
                            }
                        }else{
                            return resolve(XmlController.stripInvalidXml10Chars(xmlData));
                        }
                    }
                } else {
                    alert("Sadece XML Dosyaları Seçilebilir.");
                    return  reject({message:"Sadece XML Dosyaları Seçilebilir."})
                }
            }catch (e) {
                return  reject(e);
            }
        })

    }
    static async mtsParse(xml: string,formData: MtsDosyaFormData): Promise<MtsXmlParser[]> {
        try{
            let takipler: MtsXmlParser[] = [];
            xml = XmlController.stripInvalidXml10Chars(xml);
            let elem = document.createElement("container");
            elem.innerHTML = xml;
            let dosyaNodeList = elem.querySelectorAll("dosya");
            let dosyaIndex = 1;
            for (const dosya of dosyaNodeList) {
                try {
                    //@ts-ignore
                    let takip = await MtsXmlParser.parse(dosya, formData, dosyaIndex);
                    takipler.push(takip);
                } catch (e: any) {
                    // Hata mesajına dosya numarasını ekle
                    const dosyaPrefix = `[Dosya ${dosyaIndex}] `;
                    if (e && typeof e === 'object' && e.message) {
                        e.message = dosyaPrefix + e.message;
                    } else if (typeof e === 'string') {
                        e = dosyaPrefix + e;
                    }
                    throw e;
                }
                dosyaIndex++;
            }
            return Promise.resolve(takipler);
        }catch (e) {
            return Promise.reject(e);
        }
    }
}